import type { User } from '@/types';
import useAuth from '@/components/auth/use-auth';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import client from './client';
import { API_ENDPOINTS } from './client/endpoints';
import { posthogService } from '@/lib/posthog';

export function useMe() {
  const { isAuthorized } = useAuth();
  const { data, isLoading, error } = useQuery<User, Error>(
    [API_ENDPOINTS.USERS_ME],
    client.users.me,
    {
      enabled: isAuthorized,
      onSuccess: (data) => {
        posthogService.identify(data.id, {
          email: data.email,
          name: data.name,
        });
      },
    }
  );
  const activeSubscription = data?.subscriptions?.find(
    (sub) => sub.status === 'active'
  );
  const currentPlan = activeSubscription?.name ?? 'Free Plan';
  const currentCycle = activeSubscription?.interval ?? 'monthly';
  return {
    me: data,
    currentPlan,
    isLoading,
    error,
    isAuthorized,
    currentCycle,
    hasSubscription: currentPlan !== 'Free Plan',
  };
}

export function useLogout() {
  const { unauthorize } = useAuth();
  const queryClient = useQueryClient();
  return useMutation(client.users.logout, {
    onSuccess: () => {
      unauthorize();
      queryClient.resetQueries(API_ENDPOINTS.USERS_ME);
      posthogService.reset();
    },
  });
}
